import { compose, branch, renderNothing, withProps } from 'recompose'
import { connect } from 'react-redux'
import {
  persistAffordability,
  toggleAffordabilityModal
} from 'src/actions/affordability'
import {
  selectLoading,
  selectShowPrequalPrompt,
  selectPrequalRequested
} from 'src/store/selectors/affordability'

const AffordabilityModalContainer = compose(
  connect(
    (state, props) => ({
      isLoading: selectLoading(state),
      showPrompt: selectShowPrequalPrompt(state),
      prequalRequested: selectPrequalRequested(state)
    }),
    dispatch => ({
      toggleModal: () => dispatch(toggleAffordabilityModal()),
      persistAffordability: () => dispatch(persistAffordability())
    })
  ),
  branch(({ isLoading }) => isLoading, renderNothing),
  withProps(({ toggleModal, persistAffordability }) => ({
    onSubmit: event => {
      event.preventDefault()
      persistAffordability()
    }
  }))
)

export default AffordabilityModalContainer
